import { MAX_ATTEMPTS, WORD_LENGTH, type GuessPattern } from "@mk/shared";
import { messages } from "../i18n/index.ts";

interface GhostBoardProps {
  rows: readonly (GuessPattern | undefined)[];
  label: string;
  /** Rakip kaçıncı denemede buldu; bulamadıysa null. */
  solvedAt: number | null;
  /** Rakibin kullandığı tahmin sayısı. */
  attempts: number;
  /** Bu oyuncunun kullanabileceği toplam tahmin sayısı. */
  attemptLimit?: number;
  /** Bu maçtaki toplam satır sayısı. */
  maxAttempts?: number;
  hint?: string;
  /** Sağdaki büyük deneme sayacı. Düelloda aynı bilgi üst skorda olduğu için kapalı. */
  showCount?: boolean;
}

/**
 * Rakip şeridi — harfler YOK, yalnızca renk deseni.
 *
 * Düellonun imzası: nerede olduğunu görürsün, ne yazdığını göremezsin.
 * Alev çerçeve ve çapraz şeritler "bu tahta senin değil" der; rakip kelimeyi
 * bulunca şerit mint'e döner ve üç kez çakar.
 */
export function GhostBoard({
  rows,
  label,
  solvedAt,
  attempts,
  maxAttempts = MAX_ATTEMPTS,
  attemptLimit = maxAttempts,
  hint = messages.ghost.colorsOnly,
  showCount = true,
}: GhostBoardProps) {
  const solved = solvedAt !== null;

  return (
    <div className="ghost" data-solved={solved ? "true" : undefined}>
      <div className="stripes stripes--moving" aria-hidden="true" />

      <div className="ghost__grid" aria-hidden="true">
        {Array.from({ length: maxAttempts }, (_, r) =>
          Array.from({ length: WORD_LENGTH }, (_, c) => (
            <span
              key={`${r}-${c}`}
              className="ghost__cell"
              data-state={rows[r]?.[c]}
              data-locked={
                !rows[r] && r >= Math.max(attempts, attemptLimit) ? "true" : undefined
              }
            />
          )),
        )}
      </div>

      <div className="ghost__meta">
        <div className="ghost__name">
          <span className="live-dot" aria-hidden="true" />
          <span>{label}</span>
        </div>
        <span className="ghost__badge" role="status">
          {solved ? messages.ghost.solved(solvedAt) : messages.ghost.live}
        </span>
        <span className="ghost__hint">{hint}</span>
      </div>

      {showCount && (
        <div className="ghost__count">
          <b>
            {attempts}/{attemptLimit}
          </b>
          <span>{messages.ghost.attempt}</span>
        </div>
      )}
    </div>
  );
}
